<script>
import listComponent from '@src/router/views/prices/components/listComponent.vue'

export default {
  page: {
  },
  components: {
   listComponent
  },
  filters: {

  },

  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
    serviceCategory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
 
    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  methods: {
  },
}
</script>

<template>
<listComponent
  :merchant-products="merchantProducts" 
  :service-category="serviceCategory"
  :tableCheckboxShow="true"
  type="daycare"
/>

</template>

<style lang="scss" module>
</style>
